import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {HttpClient} from '@angular/common/http';
import {Message, Chat, Attachment, FormChat} from 'app/models';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class ChatService {
    apiUrl: string;
    token: string;

    constructor(private http: HttpClient,
                private settings: SettingsService) {
        this.apiUrl = this.settings.apiUrl;
        //this.apiUrl = 'http://localhost:3000/api';
    }

    getMessages(id): Observable<any> {
        return this.http.get(`${this.apiUrl}/message/${id}`).pipe(map((resp: any) => {
            if (resp.list) {
                return {
                    messages: resp.list.map(item => new Message().setFromApiModel(item)),
                    agent_id: resp.agent_id
                };
            } else {
                return new Chat().setFromApiModel(resp);
            }
        }));
    }

    createMessage(data): Observable<any> {
        return this.http.post(`${this.apiUrl}/message/`, data).pipe(map((msg: any) => {
            return new Message().setFromApiModel(msg);
        }));
    }
    getUnreadMessages(id): Observable<any> {
        return this.http.get(`${this.apiUrl}/message-client/${id}`).pipe(map((resp: any) => {
            return resp?.count;
        }));
    }
    updateMessage(data): Observable<any> {
        return this.http.put(`${this.apiUrl}/message/${data.id}`, data).pipe(map((msg: any) => {
            return new Message().setFromApiModel(msg);
        }));
    }

    uploadFile(data): Observable<any> {
        return this.http.post(`${this.apiUrl}/attachment/`, data).pipe(map((msg: any) => {
            return new Attachment().setFromApiModel(msg);
        }));
    }

    createChatManager(data): Observable<any> {
        return this.http.post(`${this.apiUrl}/chats/`, data).pipe(map((chat: any) => {
            return new Chat().setFromApiModel(chat);
        }));
    }

}
